import { TouchBackend } from "react-dnd-touch-backend";
import { MouseTransition, TouchTransition } from "react-dnd-multi-backend";

export const MouseToTouchBackend = {
  backends: [
    {
      id: "mouse",
      backend: TouchBackend,
      options: {
        enableMouseEvents: true,
        ignoreContextMenu: true,
      },
      transition: MouseTransition,
    },
    {
      id: "touch",
      backend: TouchBackend,
      options: {
        enableTouchEvents: true,
        delayTouchStart: 500,
        ignoreContextMenu: true,
        touchSlop: 3,
      },
      preview: true,
      transition: TouchTransition,
    },
  ],
};
